import React from 'react';
import styles from './OrderServicePanel.module.scss';
import icon1 from '@/assets/images/price250.png';
import icon2 from '@/assets/images/expressage250.png';
import FAQSection from './FAQSection';

// 规格类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}

interface OrderProduct {
  id: string;
  img: string;
  title: string;
  specs: Spec[];
  price: string;
  quantity: number;
}

interface Order {
  id: string;
  date: string;
  orderNumber: string;
  store: string;
  status: string;
  products: OrderProduct[];
  paidAmount: string;
  shippingFee: string;
}

interface Props {
  order: Order;
  onClose: () => void;
  onSelectServiceType: (type: 'refundOnly' | 'refundAndReturn') => void;
}

const OrderServicePanel: React.FC<Props> = ({ order, onClose, onSelectServiceType }) => {
  const product = order.products[0] || {img: '', title: '', price: ''};
  return (
    <div className={styles['service-panel']}>
       <div className={styles['right-panel']}>
      <div className={styles['product-header']}>
        <img className={styles['product-img']} src={product.img} alt={product.title} />
        <div className={styles['product-info']}>
          <div className={styles['product-title']}>{product.title}</div>
          <div className={styles['product-classification']}>Shape Classification: Square Handheld Wicker Basket</div>
          <div className={styles['product-price']}>${product.price}</div>
        </div>
      </div>
      <div className={styles['service-type-section']}>
        <div className={styles['section-title']}>Select Service Type</div>
        <div className={styles['service-type-list']}>
          <div className={styles['service-type-item']} onClick={() => onSelectServiceType('refundOnly')}>
            <div className={styles['icon-dollar']}>
              <img src={icon1} alt="" />
            </div>
            <div>
              <div className={styles['service-type-title']}>I'd like a refund(without returning the item)</div>
              <div className={styles['service-type-desc']}>I haven't received the product yet, or I have reached a refund agreement with the seller without returning the item.</div>
            </div>
          </div>
          <div className={styles['service-type-item']} onClick={() => onSelectServiceType('refundAndReturn')}>
            <div className={styles['icon-dollar']}>
              <img src={icon2} alt="" />
            </div>
            <div>
              <div className={styles['service-type-title']}>I want to return the item and get a refund.</div>
              <div className={styles['service-type-desc']}>I have received the item and need to return it.</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['button-box']}>
            <button className={styles['close-btn']} onClick={onClose}>Close</button>
      </div>
    </div>
    <FAQSection />
    </div>
  );
};

export default OrderServicePanel; 